<script lang="ts">
	import type { ClassValue } from "svelte/elements";
	import basket from "@core/assets/icons/basket.svg?raw";
	import imgPlaceholder from "@core/assets/icons/img-placeholder.svg?raw";
	import type { Product } from "@core/schema/Product.js";
	import { formatPrice } from "@core/utils/formatPrice.js";
	import { getCartStore } from "../contexts/cartContextKey.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import Button from "./common/Button.svelte";
	import Icon from "./common/Icon.svelte";
	import Media from "./common/Media.svelte";
	import { ButtonVariant } from "./common/getButtonClass.js";

	const { tenant } = getGlobalTemplateProps();
	const { product, class: customClass }: { product: Product; class?: ClassValue } = $props();
	const [primaryImage] = product.images;
	const cartStore = getCartStore();

	const productIndex = $derived($cartStore.value.order.products.findIndex((p) => p.productId === product.id));
	const isInCart = $derived(productIndex !== -1);
</script>

<div
	class={[
		customClass,
		"rounded-2xl flex flex-col lg:rounded-3xl border p-3 lg:p-6 max-w-73",
		isInCart ? "bg-nov-light-000 border-nov-green-100" : "bg-nov-light-100 border-nov-light-200",
	]}
>
	{#if primaryImage}
		<Media
			class="object-cover mb-4 w-full aspect-[27/20] rounded-lg"
			alt={product.name}
			height={264}
			width={352}
			source={primaryImage}
		/>
	{:else}
		<div class="bg-nov-light-000 mb-6 aspect-[27/20] rounded-lg flex items-center justify-center">
			<Icon icon={imgPlaceholder} class="w-9 text-nov-light-300" />
		</div>
	{/if}
	<h4 class="text-body17/6.5 tracking-[0.005em] mb-2 font-semibold mt-4 text-nov-red-300">
		{product.name}
	</h4>
	<p class="text-xs/5 text-nov-dark-800">
		{product.description}
	</p>
	<div class="grow flex items-end flex-row justify-between mt-4">
		<div class="text-md font-bold">
			{formatPrice(product.price, tenant.locale, false)}
		</div>
		<Button
			variant={isInCart ? ButtonVariant.InCart : ButtonVariant.Filled}
			class={["flex items-center gap-1 xs:mt-0"]}
			onclick={(): void => {
				if (isInCart) {
					void cartStore.removeProduct(productIndex);
				} else {
					void cartStore.addProduct(product, 1);
				}
			}}
		>
			<span>{isInCart ? "V košíku" : "Do košíku"}</span>
			<Icon icon={basket} class="size-5" />
		</Button>
	</div>
</div>
